import { useMutation } from "@tanstack/react-query";
import { useSessionJWT } from "utils";
import { submitKYC } from ".";

export default function useSubmitKYC() {
  const { sessionJWT } = useSessionJWT();
  return useMutation({
    mutationFn: (formData) => submitKYC(sessionJWT, formData)
  });
}
